import { FC } from 'react';
import styled from 'styled-components';
import delete_icon from '../../../../assets/delete_icon.svg';
import { colors } from '../../../../component/colors';
import { IAgent } from '../../../../store/agent/interface';
import { pxToRem } from '../../../../utils/pxToRem';

type IAgentCard = {
  handleDelete?: () => void;
  agent: IAgent;
  hideDelete?: boolean;
  className?: string;
};

export const AgentCard: FC<IAgentCard> = ({
  agent,
  hideDelete,
  handleDelete,
  className
}) => {
  return (
    <Card className={className}>
      {!hideDelete && (
        <DeleteBtn onClick={handleDelete}>
          <Icon src={delete_icon} />
        </DeleteBtn>
      )}
      <AgentImage loading={'lazy'} src={agent.file.url} />
      <AgentType>{agent.module.replace('-', ' ')}</AgentType>
      <AgentName>{agent.name}</AgentName>
      <AgentPhone>{agent.email}</AgentPhone>
      <AgentPhone>{agent.phone}</AgentPhone>
      <AgentState>{agent.state}</AgentState>
      <AgentRole>
        {` Manages ${agent.module} for SOJI within `}
        <AgentArea>{`${agent.lga.replace('-', ' ')}`}</AgentArea>
        {` metroplolis`}
      </AgentRole>
    </Card>
  );
};

const Card = styled.div`
  background: #ffffff;
  border-radius: 16px;
  display: flex;
  flex-direction: column;
  position: relative;
  max-width: 337px;
  padding: 30px 30px 20px 31px;
  width: calc(30.33% - 60px);
  margin: 0px 10px;
  margin-bottom: 48px;
  @media (max-width: 1000px) {
    width: calc(45% - 60px);
    margin: 0px 15px;
    margin-bottom: 48px;
  }
  @media (max-width: 700px) {
    width: 100%;
    margin: 0;
    margin-bottom: 48px;
  }
`;

const AgentImage = styled.img`
  border-radius: 100px;
  width: 82px;
  height: 82px;
  object-fit: cover;
  background-color: #c4c4c4;
  align-self: center;
`;

const AgentName = styled.p`
  align-self: center;
  font-family: Inter;
  font-size: ${pxToRem(18)};
  line-height: ${pxToRem(22)};
  text-transform: capitalize;
  font-weight: 700;
  text-align: center;
  letter-spacing: -0.005em;
  color: #27272e;
`;
const AgentType = styled(AgentName)`
  background-color: #e4ecf7;
  border-radius: 100px;
  align-self: center;
  padding: 8px 12px;
  margin: 24px 0px;
  font-size: ${pxToRem(12)};
  line-height: ${pxToRem(15)};
`;

const AgentPhone = styled(AgentName)`
  font-size: ${pxToRem(14)};
  line-height: ${pxToRem(23)};
  text-transform: lowercase;
  font-family: Inter;
  font-weight: 400;
  margin: 4px 0px;
`;
const AgentState = styled.p`
  font-size: ${pxToRem(14)};
  font-weight: 500;
  line-height: ${pxToRem(20)};
  text-transform: capitalize;
  letter-spacing: 0px;
  align-self: center;
  color: #a1a1a1;
`;

const AgentRole = styled.div`
  font-family: Inter;
  font-style: normal;
  font-weight: normal;
  font-size: ${pxToRem(14)};
  flex-wrap: wrap;
  line-height: ${pxToRem(23)};
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;
  color: #7a7a9d;
  text-transform: capitalize;
`;
const AgentArea = styled.span`
  font-weight: 700;
  margin: 0px 3px;
  color: ${colors.textDark};
`;
const DeleteBtn = styled.button`
  position: absolute;
  right: 24px;
  top: 16px;
  background-color: transparent;
  outline: none;
  border: none;
  padding: 0;
  & :hover {
    opacity: 0.6;
  }
`;
const Icon = styled.img`
  max-height: 48px;
  max-width: 48px;
`;
